<a [routerLink]="['/project', project.slug]" class="innerlink"></a>
<h2>{{ project.name }}</h2>
<div class="btn-go">
    <i class="fa fa-angle-right" aria-hidden="true"></i>
</div>



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/item/item.component.html